import script from "./Angular.vue?vue&type=script&setup=true&lang=ts"
export * from "./Angular.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__